"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _autobahnUtilities = require("@gcc/autobahn-utilities");

var _MdClose = require("@react-icons/all-files/md/MdClose");

var _headless = _interopRequireDefault(require("@tippyjs/react/headless"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _Link = _interopRequireDefault(require("../Link/Link.index"));

var _Tooltip = require("./Tooltip.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Tooltip = function Tooltip(props) {
  var children = props.children,
      hideOnClick = props.hideOnClick,
      id = props.id,
      interactive = props.interactive,
      linkText = props.linkText,
      onHide = props.onHide,
      onShow = props.onShow,
      placement = props.placement,
      showClose = props.showClose,
      theme = props.theme,
      trigger = props.trigger;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var hide = function hide() {
    return setVisible(false);
  };

  var popperOptions = {
    strategy: 'fixed',
    modifiers: [{
      name: 'preventOverflow',
      options: {
        rootBoundary: 'document'
      }
    }, {
      name: 'offset',
      options: {
        offset: [0, 12]
      }
    }]
  };
  return /*#__PURE__*/_react["default"].createElement(_headless["default"], {
    render: function render(attrs) {
      return /*#__PURE__*/_react["default"].createElement(_Tooltip.ToolTipBox, {
        className: "box",
        tabIndex: "-1"
      }, children, /*#__PURE__*/_react["default"].createElement(_Tooltip.ToolTipArrow, {
        "data-popper-arrow": "",
        "data-popper-placement": attrs['data-placement'],
        placement: attrs['data-placement'] ? attrs['data-placement'] : ''
      }), showClose && /*#__PURE__*/_react["default"].createElement(_Tooltip.StyledCloseButton, {
        onClick: hide,
        theme: theme
      }, /*#__PURE__*/_react["default"].createElement(_MdClose.MdClose, null)));
    },
    hideOnClick: hideOnClick,
    interactive: interactive,
    trigger: trigger,
    onClickOutside: hide,
    onHide: onHide,
    onShow: onShow,
    placement: placement,
    popperOptions: popperOptions,
    visible: trigger === 'click' ? visible : undefined
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    href: (0, _autobahnUtilities.slugify)(linkText),
    element: "button",
    id: id,
    onClick: function onClick() {
      return setVisible(!visible);
    },
    text: linkText,
    type: "standard"
  })));
};

Tooltip.propTypes = {
  /** React children, becomes the tool tip content */
  children: _propTypes.node.isRequired,

  /** Tippy hideOnClick value. Determines behaviour when user moves away from tooltip */
  hideOnClick: (0, _propTypes.oneOf)([true, false, 'troggle']),

  /** ID of the rendered link */
  id: _propTypes.string,

  /** Tippy interactive value. Whether the tooltip has interactive content */
  interactive: _propTypes.bool,

  /** Text or html of the link that will have a tooltip */
  linkText: _propTypes.node.isRequired,

  /** Tippy onHide event. */
  onHide: _propTypes.func,

  /** Tippy onShow event. */
  onShow: _propTypes.func,

  /** Tippy placement value. Which side is preffered to show the tooltip */
  placement: (0, _propTypes.oneOf)(['auto', 'auto-start', 'auto-end', 'top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'right', 'right-start', 'right-end', 'left', 'left-start', 'left-end']),

  /** Whether to show a 'X' to close the tooltip */
  showClose: _propTypes.bool,

  /** Theme object. Passed automatically by the ThemeProvider high-order component */
  theme: (0, _propTypes.shape)({}).isRequired,

  /** Tippy trigger value. When the tool tip is shown */
  trigger: (0, _propTypes.oneOf)(['click', 'mouseenter', 'focusin'])
};
Tooltip.defaultProps = {
  hideOnClick: false,
  id: '',
  interactive: false,
  onHide: function onHide() {},
  onShow: function onShow() {},
  placement: 'top',
  showClose: false,
  trigger: 'mouseenter'
};
Tooltip.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Tooltip",
  "props": {
    "hideOnClick": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Tippy hideOnClick value. Determines behaviour when user moves away from tooltip",
      "type": {
        "name": "enum",
        "value": [{
          "value": "true",
          "computed": false
        }, {
          "value": "false",
          "computed": false
        }, {
          "value": "'troggle'",
          "computed": false
        }]
      },
      "required": false
    },
    "id": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "ID of the rendered link",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "interactive": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Tippy interactive value. Whether the tooltip has interactive content",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onHide": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "Tippy onHide event.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onShow": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "Tippy onShow event.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "placement": {
      "defaultValue": {
        "value": "'top'",
        "computed": false
      },
      "description": "Tippy placement value. Which side is preffered to show the tooltip",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'auto'",
          "computed": false
        }, {
          "value": "'auto-start'",
          "computed": false
        }, {
          "value": "'auto-end'",
          "computed": false
        }, {
          "value": "'top'",
          "computed": false
        }, {
          "value": "'top-start'",
          "computed": false
        }, {
          "value": "'top-end'",
          "computed": false
        }, {
          "value": "'bottom'",
          "computed": false
        }, {
          "value": "'bottom-start'",
          "computed": false
        }, {
          "value": "'bottom-end'",
          "computed": false
        }, {
          "value": "'right'",
          "computed": false
        }, {
          "value": "'right-start'",
          "computed": false
        }, {
          "value": "'right-end'",
          "computed": false
        }, {
          "value": "'left'",
          "computed": false
        }, {
          "value": "'left-start'",
          "computed": false
        }, {
          "value": "'left-end'",
          "computed": false
        }]
      },
      "required": false
    },
    "showClose": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Whether to show a 'X' to close the tooltip",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "trigger": {
      "defaultValue": {
        "value": "'mouseenter'",
        "computed": false
      },
      "description": "Tippy trigger value. When the tool tip is shown",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'click'",
          "computed": false
        }, {
          "value": "'mouseenter'",
          "computed": false
        }, {
          "value": "'focusin'",
          "computed": false
        }]
      },
      "required": false
    },
    "children": {
      "description": "React children, becomes the tool tip content",
      "type": {
        "name": "node"
      },
      "required": true
    },
    "linkText": {
      "description": "Text or html of the link that will have a tooltip",
      "type": {
        "name": "node"
      },
      "required": true
    },
    "theme": {
      "description": "Theme object. Passed automatically by the ThemeProvider high-order component",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    }
  }
};

var _default = (0, _styledComponents.withTheme)(Tooltip);

exports["default"] = _default;